import React from 'react';
import PropTypes from 'prop-types';
import PageIntro from '../components/PageIntro';
import BusinessGames from '../components/BusinessGames';
import Meta from '../components/Meta';

export default class BusinessGamesPage extends React.Component {

    static propTypes = {
      data: PropTypes.array.isRequired,
      loading: PropTypes.bool,
      error: PropTypes.string,
      retryFetch: PropTypes.func
    }
    
    state = {
      entry: 'tyoelama-id',
      data: this.props.data,
    };

    componentDidMount() {    
      window.scrollTo(0, 0);
      document.getElementsByTagName('html')[0].classList.remove('animate');
    }

    componentDidUpdate(prevProps) {
      // Update local state when props change (e.g., after data is fetched)
      if (prevProps.data !== this.props.data) {
        this.setState({ data: this.props.data });
      }
    }

    render() {
      const { loading, error, retryFetch } = this.props;

      if (error) {
        return (
          <section className="businessgames-page">
            <div className="error-container" style={{ textAlign: 'center', padding: '50px 20px' }}>
              <h2>Error loading content</h2>
              <p>{error}</p>
              <button 
                onClick={retryFetch}
                style={{
                  padding: '10px 20px',
                  background: '#c1347a',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  marginTop: '20px'
                }}
              >
                Try again
              </button>
            </div>
          </section>
        );
      }

      // Don't show anything during loading state
      if (loading) {
        return null;
      }

      return (
        <section className="businessgames-page">
          <Meta data={this.state.data} entry={this.state.entry} />
          <PageIntro data={this.state.data} entry={this.state.entry}>
            <BusinessGames data={this.state.data} />
          </PageIntro>        
        </section>
      );
    }
}
